module.exports = __webpack_public_path__ + "img/icon_message.b847e9df.svg";